/**
* BugAnnotationEntity Interface
*
* Generated file, don't touch manually
*
* ModelVersion: 90001
*/

export { BugAnnotationEntity } from "@archipad-js/archipad-model";
